'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexps = require('./regexps');

exports.default = function (str) {
  var results = [];

  var result = void 0;
  while (result = _regexps.links.exec(str)) {
    // eslint-disable-line no-cond-assign
    results.push(result[2]);
  }

  return results;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/getLinks.js
 ** module id = 108
 ** module chunks = 0
 **/